const ComingSoon = () => import(/* webpackChunkName: "pages", webpackPrefetch: true */ "./ComingSoon");
const Error401 = () => import(/* webpackChunkName: "pages", webpackPrefetch: true */ "./Error401");
const Error404 = () => import(/* webpackChunkName: "pages", webpackPrefetch: true */ "./Error404");

export {
    ComingSoon,
    Error401,
    Error404
};